// The dashboard's single source of colour and tone.
//
// This palette was previously copy-pasted verbatim into roughly eighteen view
// files as a local `medstownColors` object, which is why status pills drifted
// between screens. Import from here instead of redeclaring it.

export const colors = {
  primary: "#014D4D",
  secondary: "#02A0A0",
  accent: "#FFB800",
  success: "#4caf50",
  error: "#f44336",
  warning: "#ff9800",
  info: "#0288d1",
};

// Neutral scale for text, borders and page background.
export const neutral = {
  bg: "#f8fafc",
  surface: "#ffffff",
  border: "#e5e7eb",
  borderSoft: "#f1f5f9",
  ink: "#0f172a",
  muted: "#64748b",
  subtle: "#94a3b8",
};

export const T = { ...colors, ...neutral };

/**
 * Order status is a free-form string in the backend schema — there is no enum
 * — so this map is matched case-insensitively on a normalised key and falls
 * back to a neutral tone rather than throwing away a status it has not seen.
 */
const STATUS_TONES = {
  delivered: colors.success,
  completed: colors.success,
  accepted: colors.success,
  verified: colors.success,
  active: colors.success,
  paid: colors.success,

  pending: colors.warning,
  processing: colors.warning,
  assigned: colors.info,
  confirmed: colors.info,
  outfordelivery: colors.info,
  shipped: colors.info,

  rejected: colors.error,
  cancelled: colors.error,
  ordercancelled: colors.error,
  failed: colors.error,
  missing: colors.error,

  refundinitiated: colors.warning,
  refundprocessing: colors.warning,
  refundcompleted: colors.success,
  refundcancelled: colors.error,
};

export function statusTone(status) {
  if (!status) return neutral.muted;
  const key = String(status).toLowerCase().replace(/[\s_-]/g, "");
  return STATUS_TONES[key] || neutral.muted;
}

// Soft background for a tone, without pulling MUI's alpha() into every caller.
export function tint(hex, opacity = 0.12) {
  const clean = String(hex).replace("#", "");
  const full =
    clean.length === 3
      ? clean.split("").map((c) => c + c).join("")
      : clean;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export const inr = (value) =>
  "₹" +
  Number(value || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const inrShort = (value) => {
  const v = Number(value || 0);
  if (v >= 1e7) return `₹${(v / 1e7).toFixed(1)}Cr`;
  if (v >= 1e5) return `₹${(v / 1e5).toFixed(1)}L`;
  if (v >= 1e3) return `₹${(v / 1e3).toFixed(1)}k`;
  return `₹${v}`;
};

export default T;
